import React from "react"
import NumberField from "../NumberField"

export default function TotalCostRow(props) {
  return (
    <tr>
      <td
        colspan={!props.colSpan ? "9" : props.colSpan}
        className="border-top-0 text-right naming"
      >
        <label>
          <span className="font-13 text-primary">{`Total ${props.moduleName} Cost (INR)`}</span>
        </label>
      </td>
      <td className={props.trClassName ? props.trClassName : ""}>
        <NumberField
          value={props.totalCostValue || "0.00"}
          name={props.name}
          onChange={props.onChange}
          // onChange= {}
          disabled={true}
        />
      </td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Costing/TotalCostRow/index.js